// extracted by mini-css-extract-plugin
export default {"container":"LoginLayout_container__Ycj76","banner":"LoginLayout_banner__C-QUj","logo":"LoginLayout_logo__1CFPQ","content":"LoginLayout_content__-1aOe"};